import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Params, useLocation, useParams,
} from 'react-router-dom';
import ValidationCodePopup from 'Components/auth/components/ValidationCodePopup';
import { selectUserData } from 'Selector/LoginSelector';
import { actions } from 'Slice/LoginSlice';
import { User } from 'Types/LoginTypes';
import { loginNavigation, setLocalStorageValue } from 'Utils/UtilityFunctions';
import styled from 'styled-components';
import { xiQLoader } from 'Utils/utilsStyle';

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  img {
    width: 140px;
  }
`;

const SSO = function SSO() {
  const [showValidationCodePopup, setShowValidationCodePopup] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const userData: User | null = useSelector(selectUserData);
  const { token } = useParams<Params>();

  useEffect(() => {
    if (token !== '') {
      setLocalStorageValue('csrfToken', token ?? '');
      dispatch(actions.getUserProfile({
      }));
    }
  }, []);

  useEffect(() => {
    if (userData === null) return;
    if (userData && userData.active === 0) {
      setShowValidationCodePopup(true);
      return;
    }
    const url = location.search.split('navigateTo=');
    loginNavigation(url[1] || '');
  }, [userData]);

  const onVerificationCodeSuccess = () => {
    loginNavigation();
    setShowValidationCodePopup(false);
  };
  const closePopup = () => {
    setShowValidationCodePopup(false);
  };

  return (
    showValidationCodePopup ? (
      <ValidationCodePopup
        onVerificationCodeSuccess={onVerificationCodeSuccess}
        onClosePopup={closePopup}
        username={userData?.email || ''}
      />
    ) : <LoaderWrapper><img src={xiQLoader} alt="loader" /></LoaderWrapper>
  );
};

export default SSO;
